import type { Locale } from "@/lib/i18n";
import { pl, type CRegisterationToNewslettersTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cRegisterationToNewslettersTranslations: Record<
  Locale,
  CRegisterationToNewslettersTranslations
> = {
  pl,
  en,
  de,
};

export type { CRegisterationToNewslettersTranslations };
